
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { ProxyCmp, initOutputs } from '../lib';
import type { JSX, Components } from '@vime/core/dist/types';

import { 
  VmPlaybackControl,
  VmControl,
  VmIcon,
  VmTooltip 
} from '@vime/core';

import { define } from '../lib';
  

const PlaybackControlInputs: string[] = [
  'playIcon',
  'pauseIcon',
  'icons',
  'tooltipPosition',
  'tooltipDirection',
  'hideTooltip',
  'keys',
  'paused',
  'i18n',
];

const PlaybackControlMethods: string[] = [
  
];

const PlaybackControlOutputs: string[] = [
  
];

export type Emitter<T extends ((...args: any[]) => any) | undefined> = EventEmitter<Parameters<Exclude<T, undefined>>[0]>;

export declare interface PlaybackControl extends Components.VmPlaybackControl {}

@ProxyCmp({
  inputs: PlaybackControlInputs,
  methods: PlaybackControlMethods,
})
@Component({
  selector: 'vm-playback-control',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: PlaybackControlInputs,
  outputs: PlaybackControlOutputs,
})
export class PlaybackControl {
  protected el: HTMLElement;

  

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    define('vm-playback-control', VmPlaybackControl);
    define('vm-control', VmControl);
    define('vm-icon', VmIcon);
    define('vm-tooltip', VmTooltip);
    c.detach();
    this.el = r.nativeElement;
    initOutputs(this, [])
  }
}
  